import { render, staticRenderFns } from "./PhoneNumberManager.vue?vue&type=template&id=070e33a4&scoped=true&"
import script from "./PhoneNumberManager.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberManager.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberManager.vue?vue&type=style&index=0&id=070e33a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e33a4",
  null
  
)

export default component.exports